import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import AllTools from './pages/AllTools';
import PayMe from './pages/PayMe';
import JollyGunjParty from './pages/JollyGunjParty';
import toolRegistry from './data/toolRegistry.json';
import toolComponents from './tools';
import './App.css';

function Layout({ children }) {
  const location = useLocation();
  const noLayoutRoutes = ['/pay', '/pay-jollygunj-party'];
  const hideLayout = noLayoutRoutes.includes(location.pathname);

  if (hideLayout) {
    return <>{children}</>;
  }

  return (
    <>
      <Header />
      <main className="main-content">{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tools" element={<AllTools />} />
            <Route path="/pay" element={<PayMe />} />
            <Route path="/pay-jollygunj-party" element={<JollyGunjParty />} />
            {toolRegistry.tools.map(tool => {
              const ToolComponent = toolComponents[tool.component];
              return ToolComponent ? (
                <Route
                  key={tool.id}
                  path={tool.path}
                  element={<ToolComponent />}
                />
              ) : null;
            })}
          </Routes>
        </Layout>
      </div>
    </Router>
  );
}

export default App;
